import { delayOffset, intersectionWatcher } from "@/lib/animation";

const selectors = {
  textContainer: '.animation--item',
  textContent: '.animation--container > *'
};

export default (node, slides) => {
  slides.forEach(slide => {
    delayOffset(slide, [selectors.textContainer, selectors.textContent], 3);
  });

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer.destroy();
    },
  };
};
